import React from "react";
import Times from "../assets/icons/times-light.svg";
import { useGlobalState } from "../context/Global";

import { PopupboxManager, PopupboxContainer } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

const NewsFlash = () => {
  const { data, closedNewsFlashes, closeNewsFlash } = useGlobalState();

  if (!data.newsflash) return null;

  const config = {
    className: "shadow-lg",
    content: {
      className: "p-8",
    },
    titleBar: {
      enabled: false,
    },
    fadeIn: true,
    fadeInSpeed: 300,
    overlayOpacity: 0.1,
    onClosed: closeNewsFlash,
  };

  const content = (
    <div>
      {!!data.newsflash.$.title && <h1 className="text-black uppercase font-bold mb-4">{data.newsflash.$.title}</h1>}
      <div dangerouslySetInnerHTML={{ __html: data.newsflash._ }} />
      <Times width="24" height="24" className="absolute right-0 top-0 mt-2 mr-2 cursor-pointer text-primary-dark" onClick={() => PopupboxManager.close()} />
    </div>
  );

  React.useEffect(() => {
    if (!closedNewsFlashes.includes(data.newsflash?.$?.id)) PopupboxManager.open({ content, config });
  }, [closedNewsFlashes]);

  return <PopupboxContainer />;
};

export default NewsFlash;
